export default {
	text: "{changedBy} changed this goal's assigned team to {to} (previously {from})",
};
